import { Injectable } from "@angular/core";
import { BillingEntry } from "./billingentry";
// import { Customer } from "src/app/customers/customers";
import { Observable, throwError, of, Subject, BehaviorSubject } from "rxjs";
import { retry, catchError, map, finalize, tap } from "rxjs/operators";
import { HttpClient, HttpHeaders } from "@angular/common/http";
// import { Subdivision } from 'src/app/subdivisions/subdivision';
import { environment } from "src/environments/environment";
import { MessagerComponent } from "src/app/messager/messager/messager.component";

@Injectable({
  providedIn: "root",
})
export class BillingService {
  private baseURL = environment.baseUrl;
  private subject = new BehaviorSubject<BillingEntry[]>([]);
  private loading = new BehaviorSubject<boolean>(true);


  gridObject$: Observable<BillingEntry[]> = this.subject.asObservable();
  loadingD$: Observable<boolean> = this.loading.asObservable();

  isLoading = true;

  constructor(private http: HttpClient, private messager: MessagerComponent) {}

  getCurrentDate() {

    const dated = new Date(Date.now());
    const dd = dated.getDate();
    const mm = dated.getMonth() + 1;

    const yyyy = dated.getFullYear();
    const day = dd < 10 ? '0' + dd : dd;
    const month = mm < 10 ? '0' + mm : mm;

    const formattedDate = month + '-' + day + '-' + yyyy;

    return formattedDate;

  }

  dateChange(fromdate: string, todate: string) {

    this.loading.next(true);
    let dateEntity = {
      dateOne: fromdate,
      dateTwo: todate,
    };

    this.isLoading = true;
    return this.http.post<any>(
      this.baseURL + "/rhAPI/jobEntry/billing/getJobsByDate",
      dateEntity
    );
  }

  updateChanges(job): Observable<any> {
    if (job.invoicecheck && job.invoice_number) {
      const billing = this.subject.getValue();
      const index = billing.findIndex((job) => job.job_id === job.job_id);

      const newBilling = billing.slice(0);

      newBilling.splice(index, 1);
      this.subject.next(newBilling);
    }

    return this.http
      .post(
        this.baseURL + "/rhAPI/jobEntry/billing/updateJob/" + job.job_id,
        job
      )
      .pipe(
        tap((event) => {
          const message = event.Message as unknown as string;
          if (event.Error) {
            this.messager.openSnackBar(message, "Close", "errorAlert");
          } else {
            this.messager.openSnackBar(message, "", "successAlert");
          }
        })
      );
  }

  getTodaysJobs(): Observable<any> {
    return this.http.get(this.baseURL + "/rhAPI/jobEntry/billing/getJobs", {
      observe: "body",
    });
  }

  getTodaysJobsWithPagination(pageSize:number,pageNO:number): Observable<any> {
    return this.http.get(this.baseURL + `/rhAPI/jobEntry/billing/getJobswithPagination/?pageSize=${pageSize}&pageNo=${pageNO}`, {
      observe: "body",
    });
  }

  getPlanInfo(job):Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/billing/getPlanInfo/' + job.job_id, {observe: 'body'});
  }

  parseCSV(obj): Observable<any> {
    return this.http.post(this.baseURL + "/rhAPI/csvfunc/parseCSV", obj, {
      observe: "body",
    });
  }
}
